import { render } from "./LeagueHistory.vue?vue&type=template&id=6c04915b&bindings={}"
import script from "./LeagueHistory.vue?vue&type=script&lang=ts"
export * from "./LeagueHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script